import React from 'react';
import { FiGrid, FiStar } from 'react-icons/fi';

const VIEW_OPTIONS = {
  grid: { label: 'Cuadrícula', actionLabel: 'Mostrar cuadrícula', icon: FiGrid },
  slots: { label: 'Favs', actionLabel: 'Mostrar favs', icon: FiStar },
};

const ProductViewToggle = ({ value, onChange, allowedViews = ['grid'] }) => {
  const options = allowedViews
    .map((view) => ({ ...VIEW_OPTIONS[view], value: view }))
    .filter((option) => option.label && option.icon);
  const currentIndex = Math.max(0, options.findIndex((option) => option.value === value));
  const nextOption = options.length > 1
    ? options[(currentIndex + 1) % options.length]
    : options[0];
  if (!nextOption) return null;

  const Icon = nextOption.icon;
  const disabled = options.length <= 1;

  return (
    <div className="flex" onClick={(event) => event.stopPropagation()}>
      <button
        type="button"
        onClick={() => {
          if (!disabled) {
            onChange(nextOption.value);
          }
        }}
        disabled={disabled}
        className={`inline-flex h-10 w-10 items-center justify-center rounded-lg border border-gray-200 bg-white shadow-sm transition-colors ${
          disabled
            ? 'text-gray-300 cursor-not-allowed'
            : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
        }`}
        title={disabled ? nextOption.label : nextOption.actionLabel}
        aria-label={disabled ? nextOption.label : nextOption.actionLabel}
      >
        <Icon size={18} />
      </button>
    </div>
  );
};

export default ProductViewToggle;
